export var ProjectRoleType;
(function (ProjectRoleType) {
    ProjectRoleType["Owner"] = "OWNER";
    ProjectRoleType["Editor"] = "EDITOR";
    ProjectRoleType["Contributor"] = "CONTRIBUTOR";
    ProjectRoleType["Viewer"] = "VIEWER";
    ProjectRoleType["None"] = "NONE";
})(ProjectRoleType || (ProjectRoleType = {}));
export var Status;
(function (Status) {
    Status["Accepted"] = "ACCEPTED";
    Status["Rejected"] = "REJECTED";
    Status["Draft"] = "DRAFT";
    Status["Pending"] = "PENDING";
})(Status || (Status = {}));
export class ProjectUtils {
    static isProjectAssumption(x) {
        return ("tenant_id" in x &&
            "id" in x &&
            "created_by" in x &&
            "deleted" in x &&
            "created_date" in x &&
            "updated_date" in x &&
            "type" in x &&
            "data" in x);
    }
    static isProjectTask(x) {
        return ("tenant_id" in x &&
            "id" in x &&
            "created_by" in x &&
            "created_date" in x &&
            "updated_date" in x &&
            "assigned_to" in x &&
            "name" in x &&
            "description" in x &&
            "type" in x &&
            "status" in x &&
            "deleted" in x &&
            "versions" in x);
    }
    static isProjectScenario(x) {
        return ("tenant_id" in x &&
            "id" in x &&
            "project_id" in x &&
            "status" in x &&
            "name" in x &&
            "description" in x &&
            "segment" in x);
    }
}
